<div class="flex flex-row justify-between items-center gap-4">
  <span class="summary" data-test-id="expert-availability-header-summary">
    {{ callDuration() }} min call · times shown in {{ timezoneName() }}
  </span>
  <div class="flex flex-row items-center gap-2">
    <button
      mat-icon-button
      aria-label="Previous dates"
      data-test-id="expert-availability-header-previous"
      [disabled]="isToday()"
      (click)="navigateBack()"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>
    <span
      class="date-range"
      data-test-id="expert-availability-header-date-range"
    >
      {{ selectedDateRange() | dateRange }}
    </span>
    <button
      mat-icon-button
      aria-label="Next dates"
      data-test-id="expert-availability-header-next"
      (click)="navigateForward()"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
    <button
      mat-stroked-button
      class="today-button"
      data-test-id="expert-availability-header-today"
      [disabled]="isToday()"
      (click)="navigateToToday()"
    >
      Today
    </button>
    <mat-button-toggle-group
      hideSingleSelectionIndicator
      class="view-toggle"
      aria-label="Calendar view"
      data-test-id="expert-availability-header-view"
      [formControl]="calendarView"
    >
      <mat-button-toggle
        data-test-id="expert-availability-header-week"
        [value]="ExpertAvailabilityCalendarView.Week"
      >
        <span class="flex flex-row items-center gap-1.5">
          <mat-icon fontSet="material-icons">view_week</mat-icon>
          Week
        </span>
      </mat-button-toggle>
      <mat-button-toggle
        data-test-id="expert-availability-header-day"
        [value]="ExpertAvailabilityCalendarView.Day"
      >
        <span class="flex flex-row items-center gap-1.5">
          <mat-icon fontSet="material-icons">view_day</mat-icon>
          Day
        </span>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</div>
